import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createExitPokerRoomToLoungeOutbound, createStandUpOutbound } from '../../api/outbound/pokerOutbounds';
import { DoubleArrowUpIcon } from '../../components/doubleArrowUpIcon';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { DrawerButton } from '../../drawer/drawerButton';
import { PaddedDrawerContainer } from '../../drawer/drawerControl';
import { ArrowTopLeftThickIcon } from '../../icons/arrowTopLeftThickIcon';
import { showConfirmMessageBox } from '../../redux/actions/messageBoxesActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { SitInOrOutButtonContainer } from './drawer/sitInOrOutButtonContainer';
export const ExitGameButtonGroup = ({ onClose }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const mySeatIndex = useAppSelector((state) => state.poker.mySeatIndex);
    const tourneyHasStarted = useAppSelector((state) => state.poker.tourneyProperties?.hasStarted);
    const isSitting = mySeatIndex !== undefined;
    const shouldAskToForfeitTourney = isSitting && tourneyHasStarted;
    const dispatchForfeitConfirmation = useCallback((outbound) => {
        dispatch(showConfirmMessageBox('Forfeit Tourney?', undefined, true, [
            {
                label: 'Yes, Forfeit',
                actions: [
                    {
                        type: 'outbound',
                        outbound
                    }
                ],
                closeAfterClick: true
            },
            {
                label: 'No, Keep Playing',
                actions: [],
                closeAfterClick: true
            }
        ]));
    }, [dispatch]);
    const onClickExitRoom = useCallback(() => {
        const outbound = createExitPokerRoomToLoungeOutbound();
        if (shouldAskToForfeitTourney) {
            dispatchForfeitConfirmation(outbound);
        }
        else {
            socketSend(outbound);
        }
        onClose();
    }, [dispatchForfeitConfirmation, onClose, shouldAskToForfeitTourney, socketSend]);
    const onClickStandUp = useCallback(() => {
        const outbound = createStandUpOutbound();
        if (shouldAskToForfeitTourney) {
            dispatchForfeitConfirmation(outbound);
        }
        else {
            socketSend(outbound);
        }
        onClose();
    }, [dispatchForfeitConfirmation, onClose, shouldAskToForfeitTourney, socketSend]);
    return (_jsxs(PaddedDrawerContainer, { isHighlighted: true, children: [_jsx(DrawerButton, { label: 'Exit Room', onClick: onClickExitRoom, testId: 'exit-room-button', startIcon: _jsx(ArrowTopLeftThickIcon, {}), variant: 'contained', size: 'large' }), isSitting && (_jsx(DrawerButton, { label: 'Stand Up', onClick: onClickStandUp, startIcon: _jsx(DoubleArrowUpIcon, {}), variant: 'contained', size: 'large' })), _jsx(SitInOrOutButtonContainer, { onButtonClicked: onClose })] }));
};
